import { useEffect, useState } from 'react';
import api from '../../../lib/apiClient';
import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'position_code', label: 'Code' },
  { key: 'position_title', label: 'Position Title' },
  { key: 'job_title', label: 'Job Title' },
  { key: 'department', label: 'Department' },
  { key: 'pay_grade', label: 'Pay Grade' },
  { key: 'work_shift', label: 'Work Shift' },
  { key: 'status', label: 'Status' },
  { key: 'current_employee_count', label: 'Currently Filled', align: 'right' },
];

export function PositionsRegisterReport() {
  const { lists } = useConfig();
  const [orgUnitOptions, setOrgUnitOptions] = useState<ReportOption[]>([]);

  useEffect(() => {
    api
      .get<{ id: number; unit_name: string }[]>('/org-units')
      .then((res) => setOrgUnitOptions(res.data.map((u) => ({ value: String(u.id), label: u.unit_name }))));
  }, []);

  return (
    <ReportView
      title="Positions / Establishment Register"
      description="Every position in the establishment, with pay grade, work shift and how many employees currently hold it."
      endpoint="/reports/hr/positions"
      columns={COLUMNS}
      filters={['category', 'status']}
      categoryOptions={orgUnitOptions}
      statusOptions={listOptions(lists, 'position_status')}
    />
  );
}
